import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CouponComponent } from '../../../modules/betting/coupon/coupon.component';
import { CouponService, SelectedOdd,} from '../../../modules/betting/common/coupon.service';
import { AccountService } from '../../../modules/navigation/common/account.service';
import { BasicService } from '../../../modules/common/basic.service';

export interface DialogData {
  selectedOdds;
  betSubmit;
  max;
  min;
  step;
  value;
}

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {

  get couponSelectedOdds():SelectedOdd[]{
    return this.couponService.couponSelectedOdds;
    // return this.couponService.globalSelectedOdds.filter(odd => 
    //   odd.turnId == this.couponService.selectionData.turnId
    //   && odd.tournamentId == this.couponService.selectionData.tournamentId)
  }
  betSubmit;
  max = 1000;
  min = 0;
  step = 10;
  thumbLabel = true;
  couponValue = 200;
  mainWallet:number;
  showFiller = false;
  
  constructor(
    private couponService: CouponService, 
    public dialog: MatDialog,
    public accountService: AccountService,
    public basicService: BasicService,
    ) {    
  };

  @Output()
  couponDialogClosed: EventEmitter<any> = new EventEmitter<any>();


  openDialog(): void {
    const dialogRef = this.dialog.open(CouponComponent, {
      // panelClass: 'my-class',
      // data: {
      //   selectedOdds: this.couponService.selectedOdds,
      //   betSubmit: this.betSubmit,
      //   max: this.max,
      //   min: this.min,
      //   step: this. step,
      //   value: this.couponValue
      // }
    });

    dialogRef.afterClosed().subscribe(couponValue => {
      this.couponValue = couponValue;
      this.couponDialogClosed.emit();
      
    });
  }

  ngOnInit() {
    this.mainWallet = this.basicService.getMainWalletValue();
  }

}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/